// @ts-nocheck
/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.3
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { useLocale } from "lib/i18n/client";
import { getTranslations } from "lib/i18n/dictionary";
import { withLocale } from "lib/i18n/path";

function Breadcrumbs({ icon, title, route, light = false }) {
  const locale = useLocale();
  const translations = getTranslations(locale);
  const chrome = translations.adminChrome;
  const routes = route.slice(0, -1);
  const localizedSegmentLabels = {
    dashboard: chrome.dashboardBreadcrumb,
    events: chrome.eventsBreadcrumb,
    messages: translations.messagesPage.navLabel,
    services: chrome.servicesBreadcrumb,
    positions: chrome.positionsBreadcrumb,
    proposals: translations.proposalsPage.navLabel,
    profile: chrome.profileFallback,
    site: translations.sitePage.navLabel,
  };
  const formatLabel = (value) => {
    if (!value) {
      return chrome.homeBreadcrumb;
    }

    return localizedSegmentLabels[value] ?? value.replace(/-/g, " ");
  };

  return (
    <SoftBox mr={{ xs: 0, xl: 8 }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
          },
        }}
      >
        <Link to={withLocale("/", locale)}>
          <SoftTypography
            component="span"
            variant="body2"
            color={light ? "white" : "dark"}
            opacity={light ? 0.8 : 0.5}
            sx={{ lineHeight: 0 }}
          >
            <Icon>{icon}</Icon>
          </SoftTypography>
        </Link>
        {routes.map((el, index) => (
          <Link
            to={withLocale(`/${routes.slice(0, index + 1).join("/")}`, locale)}
            key={`${el}-${index}`}
          >
            <SoftTypography
              component="span"
              variant="button"
              fontWeight="regular"
              textTransform="capitalize"
              color={light ? "white" : "dark"}
              opacity={light ? 0.8 : 0.5}
              sx={{ lineHeight: 0 }}
            >
              {formatLabel(el)}
            </SoftTypography>
          </Link>
        ))}
        <SoftTypography
          variant="button"
          fontWeight="regular"
          textTransform="capitalize"
          color={light ? "white" : "dark"}
          sx={{ lineHeight: 0 }}
        >
          {formatLabel(title)}
        </SoftTypography>
      </MuiBreadcrumbs>
    </SoftBox>
  );
}

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
};

export default Breadcrumbs;
